import cookieParser from 'cookie'
import clientCookie from 'js-cookie'

interface GetJWTOptions {
  req?: {
    headers: {
      cookie?: string
    }
  }
}

const getJWT = ({ req }: GetJWTOptions = {}): string | undefined => {
  let jwt: string | undefined
  const cookieHeader = req?.headers?.cookie
  if (typeof window === 'undefined' && typeof cookieHeader === 'string') {
    const cookies = cookieParser.parse(cookieHeader)
    jwt = cookies['ruler-jwt']
  } else {
    jwt = clientCookie.get('ruler-jwt')
  }
  return jwt
}

export default getJWT
